/* eslint-disable */
export default {
  confirmationInfo:
    'Vos modifications non sauvegardées de l’appel précédent seront perdues, voulez-vous vraiment travailler sur le nouvel appel ?',
  log: 'Journal',
  save: 'Enreg. et trav. sur le nouv. appel',
  discard: 'Ann. et trav. sur le nouv. Appel',
  stay: 'Rester sur le travail préc.',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
